import PortalVue from 'portal-vue'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((app) => {
  // Vue.use(PortalVue);
  app.vueApp.use(PortalVue)
})
